import { render, staticRenderFns } from "./TeleMarketAssignConfigNew.vue?vue&type=template&id=bc16a294&scoped=true"
import script from "./TeleMarketAssignConfigNew.vue?vue&type=script&lang=js"
export * from "./TeleMarketAssignConfigNew.vue?vue&type=script&lang=js"
import style0 from "./TeleMarketAssignConfigNew.vue?vue&type=style&index=0&id=bc16a294&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc16a294",
  null
  
)

export default component.exports